// extracted by mini-css-extract-plugin
module.exports = {"container":"animated_link-module__container--2TZ_t","icon":"animated_link-module__icon--3gG4H","title":"animated_link-module__title--1t2ea"};